import dayjs from 'dayjs';

export const calculateAge = (dateOfBirth?: string) => {
    if (!dateOfBirth || !/(\d{4})-(\d{1,2})-(\d{1,2})/.test(dateOfBirth)) return null;
    const birthDate = dayjs(dateOfBirth, 'YYYY-MM-DD');
    const today = dayjs();
    return today.diff(birthDate, 'year');
};

export const calculateRetirementAge = (dateOfBirth?: string) => {
    const age = calculateAge(dateOfBirth);

    if (!age || age < 55 || age >= 68) {
        return null;
    }

    const cutoffDate = dayjs('1961-03-05');
    const birthDate = dayjs(dateOfBirth);

    if (birthDate.isBefore(cutoffDate) || birthDate.isSame(cutoffDate)) {
        return 66;
    } else {
        return 67;
    }
};

export const calculateTimeToRetirement = (dateOfBirth?: string) => {
    if (!dateOfBirth || !/(\d{4})-(\d{1,2})-(\d{1,2})/.test(dateOfBirth)) return null;

    const birthDate = dayjs(dateOfBirth, 'YYYY-MM-DD');
    const retirementAge = calculateRetirementAge(dateOfBirth);

    if (retirementAge === null) {
        return null;
    }

    const retirementDate = birthDate.add(retirementAge, 'year');
    const today = dayjs();
    const monthsToRetirement = retirementDate.diff(today, 'month', true);
    return Math.ceil(monthsToRetirement);
};
